import React from "react"
import axios from "axios";
import { setup as URI_SETUP } from "../../../../config/api";
import { Switch, notification, Checkbox, Icon, Select } from 'antd';
const Option = Select.Option;
const uri_catalogs = URI_SETUP+"catalog";
const uri_hotels = URI_SETUP+"hotel";

class Catalogs extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            catalog_listing                 : [],
            group_listing                   : [],
            depend_of_catalogs              : [],
            hotels                          : {},
            selected_catalog                : {
                                                name        : {
                                                    en      : ""
                                                } },
            catalog_items_found             : [],
            finder_status                   : "",
            catalog_item                    : {
                                                _id         : "",
                                                name        : "",
                                                property_id : ""
                                            },
            status_catalog_listing          : "hide",
            status_catalog_item_modal       : "hide",
            catalog_item_action             : "new",
            status_catalog_category_modal   : "hide",
            catalog_category_action         : "new",
            background_filter               : "",
            status_confirm_item_deletion    : "hide",
            status_remove_item_modal        : "hide",
            multiselect                     : [],
            check_all                       : false,
            level                           : 0,
            add_items_selection_exec        : false,
            group                           : null,
            loading_gral_items              : false,
            count_revenue                   : true,
            count_nights                    : true
            }
            
    }

    componentWillMount(){
        this.getHotels();

    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.hotel_selected != this.props.hotel_selected) {
                if(this.state.selected_catalog.id!=undefined){
                    this.handleCatalogSelector(this.state.selected_catalog,this.state.level);
                }
        }

        if(prevProps.item_active != this.props.item_active){
            if(this.props.item_active.id!=undefined){
                this.handleCatalogSelector(this.props.item_active,this.state.level);
                this.props.activeSection("setup","catalogs",this.props.app.state.hotel_selected,"");
            }
        }
    }

    // ----------------------- Handlers -----------------------

    
    handleCountNights(checked) {this.setState({count_nights  : checked });}
    handleCountRevenue(checked) {this.setState({count_revenue  : checked });}
    
    handleCheckAll = (e) => {
        let multiselect = [];
        let catalog_items_found = this.state.catalog_items_found;
        if(e.target.checked){
            {Object.keys(catalog_items_found).map((key, index) => {
                multiselect.push(catalog_items_found[key]._id.$oid);
                catalog_items_found[key].checked = true;
            })}
        }else{
            {Object.keys(catalog_items_found).map((key, index) => {
                catalog_items_found[key].checked = false;
            })}
        }

        this.setState({
            check_all: e.target.checked,
            multiselect : multiselect,
            catalog_items_found : catalog_items_found
          });
        
      }
    
    
    handleMultipleSelector(id,key){
        let multiselect = this.state.multiselect;
        let catalog_items_found = this.state.catalog_items_found;
        if(multiselect.includes(id)){
            multiselect.splice( multiselect.indexOf(id), 1 );
            catalog_items_found[key].checked = false;
        }else{
            multiselect.push(id);
            catalog_items_found[key].checked = true;
        }
        this.setState({ multiselect, catalog_items_found, check_all:false });
    }

    handleFindCatalogItemsChange = (e) => {
        let self = this;
        if (e.target.value.trim()=="") {
            self.setState({ 
                catalog_items_found             : [],
                finder_status                   : ""
                })
        } else {
            axios.get(uri_catalogs+"/"+self.state.selected_catalog.id, { 
                params: {
                    api_token           : localStorage.getItem("api_token"),
                    gral_item_like      : e.target.value,
                    property_id         : self.props.hotel_selected,
                    mode                : 'find_gral_items'
                }
            }).then(request => { 
                if(request.data.length>0){
                    self.setState({ 
                        catalog_items_found             : request.data,
                        finder_status                   : "finding"
                        }) 
                }else{
                    self.setState({ 
                        catalog_items_found             : [],
                        finder_status                   : ""
                        }) 
                }
                
            })
        }
    }

    handleCatalogItemSelector(item,action) {
        let self = this;
        var qs = require("qs");
        
        const itemToSent = qs.stringify({
            api_token           : localStorage.getItem("api_token"),
            property_id         : self.props.hotel_selected,
            action              : action
        });
        axios.post(uri_catalogs+"/"+self.state.selected_catalog.id+"/"+item, itemToSent)
        .then(request => { 
            notification.open({
                message: request.data.result.type,
                description: request.data.result.message,
              });
            self.handleCatalogSelector(self.state.selected_catalog,self.state.level) ;
            self.setState({ 
                catalog_items_found    : [],
                check_all : false
                }) 
        })   

    }

    handleCatalogAddItemsSelected() {
        let self = this;
        var qs = require("qs");
        self.setState({ add_items_selection_exec : true }) 
        //console.log(self.state.multiselect.length);
        const itemToSent = qs.stringify({
            api_token           : localStorage.getItem("api_token"),
            property_id         : self.props.hotel_selected,
            mode                : 'items_to_catalog',
            multiselect         :  self.state.multiselect.toString()
        });
        axios.post(uri_catalogs+"/"+self.state.selected_catalog.id, itemToSent)
        .then(request => { 
            notification.open({ 
                message: request.data.result.type,
                description: request.data.result.message,
              });
            self.handleCatalogSelector(self.state.selected_catalog,self.state.level) ;
            self.setState({ 
                catalog_items_found         : [],
                check_all                   : false,
                add_items_selection_exec    : false
                }) 
        })   

    }

    handleCatalogSelector(catalog,level=0) {
        let self = this;
        
        self.setState({ depend_of_catalogs : [], check_all : false, loading_gral_items : true, level }) 
        
        if(catalog.depends_of != undefined){
            Object.keys(catalog.depends_of).map((key, index) => {

                axios.get(uri_catalogs+"/"+catalog.depends_of[key].id, { 
                    params: {
                        api_token   : localStorage.getItem("api_token"),
                        mode        : "imported_free"
                    }
                }).then(request => {

                    if(request.data[0]!=undefined){
                        let catalog_item = Object.assign({}, self.state.catalog_item);
                        catalog_item[catalog.depends_of[key].id] = request.data[0]._id.$oid;
                        self.setState({catalog_item});
                        
                        self.setState({ 
                        depend_of_catalogs : 
                                        {
                                            [key] : {
                                            _id         : catalog.depends_of[key]._id,
                                            id          : catalog.depends_of[key].id,
                                            value       : "",
                                            list        : request.data
                                        }
                                    }
                        })
                    }
                })

            })
            
        }

        axios.get(uri_catalogs+"/"+catalog.id, { 
            params: {
                api_token       : localStorage.getItem("api_token"),
                mode            : 'edit',
                property_id     : self.props.hotel_selected,
                level           : level
            }
        }).then(request => { 
            self.setState({ 
            catalog_listing          : request.data.catalogs,
            group_listing            : request.data.groups,
            selected_catalog         : catalog,
            status_catalog_listing   : ""
            }) 
        });

        axios.get(uri_catalogs+"/"+catalog.id, { 
            params: {
                api_token           : localStorage.getItem("api_token"),
                property_id         : self.props.hotel_selected,
                mode                : 'find_gral_items',
                level               : level
            }
        }).then(request => { 
            if(request.data.length>0){
                self.setState({ 
                    catalog_items_found             : request.data,
                    loading_gral_items              : false
                    }) 
            }else{
                self.setState({ 
                    catalog_items_found             : [],
                    loading_gral_items              : false
                    }) 
            }
            
        })

    }

    handleEditCatalogItem(catalogItem) {
        let self = this;
        if(catalogItem.magnum_alias!=undefined){
            self.setState({ 
                status_catalog_item_modal      : "",
                background_filter              : "blur",
                catalog_item_action            : "edit",
                catalog_item                   : catalogItem,
                group                          : catalogItem.magnum_alias.name
                });
        }else{
            self.setState({ 
                status_catalog_item_modal      : "",
                background_filter              : "blur",
                catalog_item_action            : "edit",
                catalog_item                   : catalogItem
                });
        }
        
    }

    handleNewCatalogItem() {
        let self = this;
        self.clearCatalogItem();
        self.setState({ 
            status_catalog_item_modal      : "",
            background_filter              : "blur",
            catalog_item_action            : "new",
            group                          : null
            })
    }

    handleCatalogItemChange = (e) => {
        let catalog_item = Object.assign({}, this.state.catalog_item);
        catalog_item[e.target.name] = e.target.value;
        this.setState({catalog_item});
    }

    handleRemoveItem(catalogItem) {
        let self = this;
        self.setState({ 
            status_remove_item_modal      : "",
            background_filter              : "blur",
            catalog_item                   : catalogItem
            })
        
    }

    handleDependenceChange = (e) => {
        let catalog_item = Object.assign({}, this.state.catalog_item);
        catalog_item[e.target.attributes.getNamedItem('data-key').value] = e.target.value;
        this.setState({catalog_item});
    }

    handleSaveItemKeyPress = (event) => {
        if(event.key == 'Enter'){
            event.preventDefault();
            this.onSubmitCatalogItem();
        }
    }

    handleCatalogLevel = (e) => {
        this.setState({
            level : e.target.value
        });
        this.handleCatalogSelector(this.state.selected_catalog,e.target.value);
    }

    handleGroup (value){
        let self = this;  
        self.setState({
            group : value[(value.length-1)]
        });
    }

    // ----------------------- Functions -----------------------
    
    cancelCatalogItem(e){
        let self = this;
        e.preventDefault();
        self.setState({ 
            status_catalog_item_modal    : "hide",
            background_filter            : "",
            group                        : null
            })
    }

    clearCatalogItem(){
        let self = this;
        let catalog_item = Object.assign({}, self.state.catalog_item);
        catalog_item["_id"]="";
        catalog_item["name"]="";
        self.setState({catalog_item});
    }

    onSubmitCatalogItem(){
        let self = this;
        var qs = require("qs");

        let catalog_item = Object.assign({}, self.state.catalog_item);
        catalog_item["property_id"]=self.props.app.state.hotel_selected;
        catalog_item["api_token"]=localStorage.getItem("api_token");
        if(self.state.level>0){
            catalog_item["level"]=self.state.level;
        }
        
        if(self.state.group!=undefined && self.state.group!=null  ){
            catalog_item["group"]=self.state.group;
        }
        //console.log(self.state.selected_catalog.id);
        if (self.state.selected_catalog.id =='status_reserve'){
            catalog_item["count_nights"]=self.state.count_nights;
            catalog_item["count_revenue"]=self.state.count_revenue;
        }

        self.setState({catalog_item});
        
        const catalogItemToSent = qs.stringify(catalog_item);
        if(self.state.catalog_item_action=="new"){
            axios.post(uri_catalogs+"/"+self.state.selected_catalog.id, catalogItemToSent)
                    .then(request => { 
                        notification.open({
                            message: request.data.result.type,
                            description: request.data.result.message,
                          });
                    })
        }else{
            axios.post(uri_catalogs+"/"+self.state.selected_catalog.id+"/"+self.state.catalog_item._id.$oid, catalogItemToSent)
            .then(request => { 
                notification.open({
                    message: request.data.result.type,
                    description: request.data.result.message,
                  });
            })   

        }

        self.handleCatalogSelector(self.state.selected_catalog,self.state.level);
        self.setState({ 
            status_catalog_item_modal      : "hide",
            background_filter              : ""
            })
        
    }

    getHotels() {
        let self = this;
        axios.get(uri_hotels, { 
            params: {
                api_token   : localStorage.getItem("api_token")
            }
        }).then(request => { 
            self.setState({ 
            hotels                  : request.data
            }) 
            
        })
    }
    
    confirmItemDeletion(e) {
        let self = this;
        e.preventDefault();
        var qs = require("qs");

        const valuesToSent = qs.stringify({
            api_token   : localStorage.getItem("api_token")
        });

        axios.post(uri_catalogs+"/"+this.state.selected_catalog.id+"/"+this.state.catalog_item._id.$oid+"/destroy", valuesToSent)
            .then(request => {
                notification.open({
                    message: request.data.result.type,
                    description: request.data.result.message,
                  });
                self.setState({     
                    status_remove_item_modal        : "hide",
                    background_filter               : ""
                }) 
        })
        self.handleCatalogSelector(self.state.selected_catalog,self.state.level);

    }

    cancelConfirmItemDeletion(e){
        let self = this;
        e.preventDefault();
        self.setState({ 
            status_remove_item_modal    : "hide",
            background_filter           : ""
            })
    }


    // ----------------------- Renders -----------------------

    renderCatalogs() {
        let self = this;
        return <ul>
                    {   
                        this.props.catalogs.map(function(catalog, i) {
                            if(catalog.type.indexOf("hotels")>=0){
                                return (<li className="clickable" key={catalog.id} onClick={self.handleCatalogSelector.bind(self, catalog, 0)} >
                                    <div>{catalog.name.en}<i className="fa fa-plus-circle"></i></div>
                                </li>);
                                }
                            })
                    }
                </ul>   
    }

    renderCatalogActions(item){
        if(item.property!=undefined){
            return <div>
                        {item.name}
                        <i className="fa fa-times-circle remove clickable" onClick={this.handleRemoveItem.bind(this,item)} ></i>
                        <i className="fa fa-pencil edit clickable" onClick={this.handleEditCatalogItem.bind(this,item)}></i>
                    </div>;
        }else{
            return  <div>
                        {item.name}
                        <i className="fa fa-times-circle remove clickable" onClick={this.handleCatalogItemSelector.bind(this, item._id.$oid,'hide_for_hotel')}></i>
                    </div>;
        }
    }

    renderCatalogItemsFound() {
        return  <ul>
                    { (this.state.loading_gral_items) &&
                        <li className=" loading"> 
                            <Icon type="loading" />
                        </li>
                    }
                    { (!this.state.loading_gral_items) &&
                        Object.keys(this.state.catalog_items_found).map((key, index) => {
                        return (<li key={this.state.catalog_items_found[key]._id.$oid} >
                                    <div>
                                        {this.state.catalog_items_found[key].name}
                                        <i className="fa fa-plus-circle clickable"  onClick={this.handleCatalogItemSelector.bind(this,this.state.catalog_items_found[key]._id.$oid,'available_for_hotel')}></i>
                                        <Checkbox name={key} value={this.state.catalog_items_found[key]._id.$oid} onChange={this.handleMultipleSelector.bind(this,this.state.catalog_items_found[key]._id.$oid,key)} checked={(this.state.catalog_items_found[key].checked = undefined? false : this.state.catalog_items_found[key].checked )}> </Checkbox>
                                    </div>
                                </li>);
                        })
                    }
                </ul>   
    }
    
    renderCatalogItems() {
        return  <ul>
                    <li className="list-header"><div className="label">{this.state.selected_catalog.name.en} </div></li>
                    {(this.state.selected_catalog['allow_groups']!=undefined) &&
                        <li className="radio-inlist">
                            <div className="form-row">
                                <div className="col-md-2 col-md-offset-1"> Display </div>
                                <div className="col-md-6 col-md-offset-2">  
                                    <select className="form-control" name="llver" value={this.state.level} onChange={e => this.handleCatalogLevel(e)}  >
                                        <option value="0">Values</option>
                                        <option value="1">Groups</option>
                                    </select>  
                                </div>
                            </div>
                        </li>
                    }
                    { (this.state.catalog_items_found.length>0) &&
                        <li className="radio-inlist">
                            { (!this.state.add_items_selection_exec) &&
                                <div className="form-row">
                                    <div className="col-md-4 col-md-offset-1"> Check All </div>
                                    <div className="col-md-5 fa-big">  
                                        <Checkbox onChange={this.handleCheckAll} checked={this.state.check_all}> </Checkbox>
                                        <i className="fa fa-plus-circle clickable"  onClick={this.handleCatalogAddItemsSelected.bind(this)}></i>
                                    </div>
                                </div>
                            }
                            { (this.state.add_items_selection_exec) &&
                                <div className=" loading"> 
                                    <Icon type="loading" />
                                </div>
                            }
                        </li>
                    }
                    <li className="finder no-padding ">
                        { (!this.state.add_items_selection_exec) &&
                            this.renderCatalogItemsFound() 
                        } 
                    </li>

                    { this.state.catalog_listing!=undefined &&
                        Object.keys(this.state.catalog_listing).map((key, index) => {
                        if (!this.state.catalog_listing[key].imported){
                        return (<li key={this.state.catalog_listing[key]._id.$oid} >
                                   { this.renderCatalogActions(this.state.catalog_listing[key]) }
                                </li>);
                        }
                    })
                    }
                </ul>   
    }

    renderDependsOfSelects() {
        if(this.state.depend_of_catalogs!=[]){
            
            return Object.keys(this.state.depend_of_catalogs).map((key, index) => {
                    return ( <div key={index} className="form-row">
                                <div className="col col-md-12">
                                    <select className="form-control" name={ this.state.depend_of_catalogs[key].id } 
                                            onChange={e => this.handleDependenceChange(e)}
                                            data-key={this.state.depend_of_catalogs[key].id} 
                                            value={ (this.state.catalog_item[this.state.depend_of_catalogs[key].id]!=undefined)?
                                            this.state.catalog_item[this.state.depend_of_catalogs[key].id] : ""}  
                                        >
                                        { Object.keys(this.state.depend_of_catalogs[key].list).map((key_list, index) => {
                                                if (!this.state.depend_of_catalogs[key].list[key_list].imported && this.state.depend_of_catalogs[key].list[key_list]._id!= undefined){
                                                    return( <option key={index} value={this.state.depend_of_catalogs[key].list[key_list]._id.$oid} >
                                                        {this.state.depend_of_catalogs[key].list[key_list].name}
                                                    </option>);
                                                }
                                            })
                                        }
                                    </select>   
                                </div>
                            </div>
                            );
                    });
        }  
    }

    renderCatalogItemModal() {
        const shouldRenderOptions = (this.state.group_listing!=undefined && this.state.group_listing.length>0)? true : false;
        return <div className="box regular col-md-4 ">
                    <h3>{this.state.catalog_item_action=="new"? "NEW CATALOG ": "EDIT CATALOG " } {this.state.level==0? "ITEM": "GROUP" } <i className="fa fa-times-circle" onClick={this.cancelCatalogItem.bind(this)} ></i> </h3>
                    <div className="form-in-box">
                        <form id="catalog_item_form">
                            <input type="hidden" name="catalog_item" value={(this.state.catalog_item._id.$oid==null)? "": this.state.catalog_item._id.$oid} /> 
                            <div className="form-row">
                                <div className="col col-md-12">
                                    <label htmlFor="name">{this.state.catalog_item_action=="new"? "Add new catalog ": "Edit catalog " } {this.state.level==0? "item": "group" }</label>
                                    <input type="text" className="form-control" name="name" placeholder="Name" value={(this.state.catalog_item.name==null)? "": this.state.catalog_item.name} required onChange={e => this.handleCatalogItemChange(e)} onKeyPress={this.handleSaveItemKeyPress}  />          
                                </div>
                            </div>
                            {(this.state.selected_catalog.id =='status_reserve') &&
                                <div className="form-row">
                                    <div className="col col-md-12">
                                        <label>Magnum should count:</label>      
                                    </div>
                                    <div className="col col-md-2">
                                        Nights:    
                                    </div>
                                    <div className="col col-md-2">
                                        <Switch onChange={this.handleCountNights.bind(this)} checked={this.state.count_nights}  />   
                                    </div>
                                    <div className="col col-md-2">
                                        Revenue:     
                                    </div>
                                    <div className="col col-md-2">
                                        <Switch onChange={this.handleCountRevenue.bind(this)} checked={this.state.count_revenue}  />   
                                    </div>
                                </div> 
                            }


                            { (this.state.level==0 && this.state.selected_catalog['allow_groups']!=undefined ) && 
                            
                                <div className="form-row">
                                    <div className="col col-md-5">
                                        <label>Group:</label>      
                                    </div>
                                    <div className="col col-md-7">
                                        {(shouldRenderOptions) ? (
                                            <Select
                                                mode="tags"
                                                placeholder="Select or create one"
                                                style={{ width: '100%' }}
                                                onChange={this.handleGroup.bind(this)}
                                                value = {this.state.group}
                                            >
                                                { Object.keys(this.state.group_listing).map((index) => {
                                                        return <Option key={ this.state.group_listing[index] }>{ this.state.group_listing[index] }</Option>
                                                    })
                                                }
                                            </Select>   
                                        ) : (
                                            <Select
                                                mode="tags"
                                                placeholder="Select or create one"
                                                style={{ width: '100%' }}
                                                onChange={this.handleGroup.bind(this)}
                                                value = {this.state.group}
                                            >
                                            </Select> 
                                        ) }
                                    </div>
                                </div>
                            }
                            { this.state.level==0 && this.renderDependsOfSelects() }
                            <div className="form-row">
                                <div className="col col-md-6">
                                    <button onClick={this.cancelCatalogItem.bind(this)}>CANCEL</button>   
                                </div>
                                <div className="col col-md-6">
                                    <button type="button" className="blue" onClick={this.onSubmitCatalogItem.bind(this)} >SAVE</button> 
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

    }

    renderConfirmItemDeletion() {
        return <div className="box notifications col-md-4 ">
                    <h3>NOTIFICATION <i className="fa fa-times-circle" onClick={this.cancelConfirmItemDeletion.bind(this)} ></i> </h3>
                    <div className="form-in-box">
                        <form id="brand_form" onSubmit={this.confirmItemDeletion.bind(this)}>
                            <div className="form-row">
                                <div className="col col-md-12">
                                    <h4>Are you sure to continue?</h4>
                                    <p>By confirming this proccess you accept to remove all the dependences for this element, any information related to it need to be reassigned</p>
                                </div>
                                <div className="form-row">
                                    <div className="col col-md-6">
                                        <button onClick={this.cancelConfirmItemDeletion.bind(this)}>CANCEL</button>   
                                    </div>
                                    <div className="col col-md-6">
                                        <button type="submit" className="blue">CONFIRM</button> 
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
    }

    render() {
        return (
            <section>
                <div className={this.state.background_filter}>
                    <div className="top-form no-padding">
                        <form id="catalog_item_form"  >
                            <div className="form-row">
                                <div className="col col-md-3 no-padding">
                                    {this.props.renderSelectHotels()}
                                </div>
                                
                            </div>
                        </form>
                    </div>

                    <div className="head-content "> 
                        <div className="icon col-md-2 px-2">
                            <h1>Setup</h1>
                            <h2>Hotel Information</h2>
                        </div>
                        <div className="col-md-8 px-2">    
                            
                            <div className="description">
                                <p className="desc-no-icon"><strong>Here you will setup the hotel-specific catalogs </strong> <br/> Create hotel catalogs by telling Magnum Leap the KPIs that you want the system to analyze per hotel. These KPIs can also be anything you choose – agencies, plan types, segments, etc.</p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-12 no-padding"> 
                        <div className="box regular col-md-3">
                            <h3>KIND OF DATA</h3>
                            <div className="list-in-box">
                                <ul>
                                    <li><div className="clickable">PMS <i className="fa fa-plus-circle"></i></div></li>
                                </ul>
                            </div>
                        </div>
                        <div className="box regular col-md-4">
                            <h3>CATALOG</h3>
                            <div className="list-in-box">
                                {this.renderCatalogs()}
                            </div>
                        </div>
                        <div className={"box regular col-md-5 " + this.state.status_catalog_listing}>
                            <h3> CATALOG LIST </h3>
                            <div className="list-in-box">
                                {this.renderCatalogItems()}
                                <button className="blue" onClick={this.handleNewCatalogItem.bind(this)}>NEW +</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={"modal " + this.state.status_catalog_item_modal}> 
                    {this.renderCatalogItemModal()}
                </div>

                <div className={"modal " + this.state.status_remove_item_modal}> 
                    {this.renderConfirmItemDeletion()}
                </div>

            </section>
        )
    }

}

export default Catalogs


// WEBPACK FOOTER //
// ./src/Setup/modules/setup/views/property/Catalogs.js